import React, { forwardRef, useRef, useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";

const TooltipWrapper = forwardRef(
  (
    {
      tooltipText,
      placement = "up",
      className = "",
      children,
      show = true,
      id = "tooltip-id",
      checkOverflow = false,
    },
    ref
  ) => {
    const childRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(true);

    useEffect(() => {
      if (childRef.current && checkOverflow) {
        const { scrollWidth, offsetWidth } = childRef.current;
        setIsOverflowing(scrollWidth > offsetWidth);
      }
    }, [children, checkOverflow]);

    if (!React.isValidElement(children)) {
      console.error("TooltipWrapper: children is not a valid React element");
      return null;
    }

    const newChildren = React.cloneElement(children, {
      'data-tooltip-id': id,
      'data-tooltip-content': tooltipText,
      direction: placement,
      className: `${children.props.className || ""} ${className}`,
      ref: childRef
    });
    
    if (!show || !isOverflowing) return <>{newChildren}</>;

    return <>
      {newChildren}
      <Tooltip id={id} className={`text-break-space z-i-3`} appendTo={document.body}/>
    </>;
  }
);

export default TooltipWrapper;
